module.exports = __webpack_public_path__ + "img/banner-31.3650843b.jpg";